function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M20,20 L20,14 L22,14 L22,20 L22,22 L14,22 L14,20 L20,20 Z M4,20 L10,20 L10,22 L2,22 L2,20 L2,14 L4,14 L4,20 Z M20,2 L22,2 L22,10 L20,10 L20,4 L14,4 L14,2 L20,2 Z M4,2 L10,2 L10,4 L4,4 L4,9 L2,9 L2,2 L4,2 Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/fullscreen.1511e961.svg";
export { SvgComponent as ReactComponent };